import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { FaCalendarAlt, FaArrowDown, FaPercentage, FaShieldAlt, FaUserShield, FaServer } from "react-icons/fa";
import TrustedCompanies from "../components/TrustedCompanies.js";
import TestimonialSection from "../components/imgration/TestimonialSection.js";
import CloudProviders from "../components/imgration/CloudProviders.js";
import MigrationGuides from "../components/imgration/MigrationGuides.js";
import WhyCloudMigration from "../components/imgration/WhyCloudMigration.js";
import OtherPlatforms from "../components/imgration/OtherPlatforms.js";
import CustomerPortalSection from "../components/imgration/CustomerPortalSection.js";
import ContactSection from "../components/imgration/ContactSection.js";
import AzureCostComparisonSection from "../components/imgration/AzureCostComparisonSection.js";
import AzureServiceMappingSection from "./AzureServiceMappingSection.js";
import AzureCaseStudySection from "../components/imgration/AzureCaseStudySection.js";
import AzureProcessSection from "../components/imgration/AzureProcessSection.js";
import WhySection from "../components/imgration/WhySection.js";
import AzureFAQSection from "../components/imgration/AzureFAQSection.js";
import OtherProvidersSection from "../components/imgration/OtherProvidersSection.js";
import AzureBlogSection from "../components/imgration/AzureBlogSection.js";
import ReviewsSection from "../components/imgration/ReviewsSection.js";
import Reaquestconsultation from "../components/imgration/RequestConsultation.js";
import { useNavigate } from "react-router-dom";
import HetznerServicesSection from "../components/HetznerServicesSection .js";
import HetznerInstallationSection from "../components/HetznerInstallationSection.js";
import HetznerSecuritySection from "../components/HetznerSecuritySection.js";
import HetznerServiceIncludedSection from "../components/HetznerServiceIncludedSection.js";
import HetznerInstallationCTA from "../components/HetznerInstallationCTA.js";
import HetznerUsercases from "../components/HetznerUsercases.js";


const Hetzner = () => {
const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const navigate = useNavigate()
   const requstconsultation = ()=>{
const element = document.getElementById("contact");
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
  }

  const hetznerdm  = ()=>{
const element = document.getElementById("installation");
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
  }
  
  return (
    <>
      <Helmet>
        <title>Azure Infrastructure Migration – Save up to 98% on Costs  | Ayanshtech Solutions</title>
        <meta
          name="description"
          content="Migrate your cloud infrastructure from Azure, Azure, Google Cloud, DigitalOcean, OVH, Scaleway, and Linode to cost-effective alternatives without compromising performance or security."
        />
        <meta property="og:title" content="Cloud Migration – Exit Expensive Hyperscalers" />
        <meta property="og:description" content="Save up to 98% on cloud hosting costs. 100% GDPR compliant and EU hosting possible." />
        <meta property="og:type" content="website" />
      </Helmet>
      <Reaquestconsultation isOpen={isModalOpen} onClose={closeModal} />
      {/* Main Container */}
      <section className="relative overflow-hidden  min-h-[calc(100svh-98px)] md:min-h-[calc(100vh-104px)] md:mt-[104px] flex items-center py-16" >
        <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 w-full z-10">
          <div className="text-center max-w-4xl mx-auto">
            <div>
              <div className="mb-4 transition-all duration-700 opacity-100 translate-y-0">
                <span className="text-green-600 font-semibold text-xs uppercase tracking-wider">Hetzner</span>
                </div>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold  text-gray-800 mb-4 transition-all duration-700 delay-100 opacity-100 translate-y-0">Cloud Solutions <span className="text-green-600"> with AyanshTech </span><span className="text-yellow-500"> Solutions and Hetzner</span><br></br>
              </h1>
              <p className="text-base text-gray-600 md:text-lg  leading-relaxed mb-8 max-w-3xl mx-auto transition-all duration-700 delay-200 opacity-100 translate-y-0">We take your business to the <span className="text-green-600" >cloud</span> — securely, efficiently, and cost-effectively.</p>
              <div className="mb-8 flex flex-col items-center transition-all duration-700 delay-300 opacity-100 translate-y-0"><div className="bg-white/10 backdrop-blur-lg rounded-2xl p-6 border border-yellow-500 max-w-4xl"><p className="text-gray-800 text-base leading-relaxed">AyanshTech Solutions is your trusted expert for <span className="text-green-600 font-bold">secure, scalable,</span>and custom<span className="text-green-600 font-bold"> cloud solutions</span>.</p></div></div>
              <div className="flex flex-col sm:flex-row gap-3 justify-center transition-all duration-700 delay-400 opacity-100 translate-y-0">
                <button onClick={openModal}  className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-blue-600 to-green-500 text-white text-sm font-semibold rounded-lg hover:bg-brand-hover transition-all cursor-pointer">
                <svg className="mr-2 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"></path>
                </svg>Request Consultation</button>
                
                </div>
                <TrustedCompanies/>
            </div>
          </div>
        </div>
      </section>
            <div className=" border-white/5">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <p className="text-xs leading-relaxed text-gray-600 " role="note">
             All trademarks are the property of their respective owners. Hetzner is a trademark of Hetzner Online GmbH. AyanshTech Solutions is an independent technology and cloud services provider and is not affiliated with, endorsed by, or partnered with Hetzner. We offer independent cloud migration, hosting, infrastructure management, and operational support services.
            </p>
          </div>
        </div>
          <section className="py-10 ">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16 fade-in-up transition-all duration-700 animate-in">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">About Hetzner</h2>
        <div className="accent-line h-1 bg-green-500 mx-auto mb-6 transition-all duration-700 ease-out w-16"></div>
        <div className="max-w-3xl mx-auto text-lg text-gray-600 space-y-4">
        <p>
  Through our <span className="text-green-500 font-semibold">cloud expertise</span>, businesses can reduce infrastructure costs, improve performance, and achieve greater operational efficiency with <span className="text-green-500 font-semibold">reliable</span> and <span className="text-green-500 font-semibold">future-ready</span> cloud solutions.
</p>
          <p>
  Hetzner enables businesses to reduce infrastructure costs while maintaining <span className="text-green-500 font-semibold">security</span>, <span className="text-green-500 font-semibold">performance</span>, and <span className="text-green-500 font-semibold">reliability</span> through its efficient cloud and hosting products.
</p>
        </div>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="group fade-in-up transition-all duration-700 animate-in" >
          <div className="relative overflow-hidden rounded-2xl bg-white border border-gray-300 p-6 hover:shadow-xl transition-all duration-500">
            <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-blue-500 to-green-500 opacity-10 rounded-full -mr-10 -mt-10"></div>
            <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-blue-500 rounded-xl mb-4 group-hover:scale-105 transition-transform duration-300 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon" className="w-6 h-6 text-white">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15a4.5 4.5 0 0 0 4.5 4.5H18a3.75 3.75 0 0 0 1.332-7.257 3 3 0 0 0-3.758-3.848 5.25 5.25 0 0 0-10.233 2.33A4.502 4.502 0 0 0 2.25 15Z"></path>
              </svg>
            </div>
            <h3 className="font-semibold text-gray-900 text-lg">Cloud Migration</h3>
          </div>
        </div>
        <div className="group fade-in-up transition-all duration-700 animate-in" >
          <div className="relative overflow-hidden rounded-2xl bg-white border border-gray-300 p-6 hover:shadow-xl transition-all duration-500">
            <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-blue-600 to-green-500 opacity-10 rounded-full -mr-10 -mt-10"></div>
            <div className="w-12 h-12 bg-gradient-to-br from-green-600 to-blue-500 rounded-xl mb-4 group-hover:scale-105 transition-transform duration-300 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon" className="w-6 h-6 text-white">
                <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 17.25v-.228a4.5 4.5 0 0 0-.12-1.03l-2.268-9.64a3.375 3.375 0 0 0-3.285-2.602H7.923a3.375 3.375 0 0 0-3.285 2.602l-2.268 9.64a4.5 4.5 0 0 0-.12 1.03v.228m19.5 0a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3m19.5 0a3 3 0 0 0-3-3H5.25a3 3 0 0 0-3 3m16.5 0h.008v.008h-.008v-.008Zm-3 0h.008v.008h-.008v-.008Z"></path>
              </svg>
            </div>
            <h3 className="font-semibold text-gray-900 text-lg">  Infrastructure Management
</h3>
          </div>
        </div>
        <div className="group fade-in-up transition-all duration-700 animate-in" >
          <div className="relative overflow-hidden rounded-2xl bg-white border border-gray-300 p-6 hover:shadow-xl transition-all duration-500">
            <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-green-500 to-blue-500 opacity-10 rounded-full -mr-10 -mt-10"></div>
            <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-blue-500 rounded-xl mb-4 group-hover:scale-105 transition-transform duration-300 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon" className="w-6 h-6 text-white">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"></path>
              </svg>
            </div>
            <h3 className="font-semibold text-gray-900 text-lg">DevOps & Automation</h3>
          </div>
        </div>
        <div className="group fade-in-up transition-all duration-700 animate-in" >
          <div className="relative overflow-hidden rounded-2xl bg-white border border-gray-300 p-6 hover:shadow-xl transition-all duration-500">
            <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-green-600 to-blue-600 opacity-10 rounded-full -mr-10 -mt-10"></div>
            <div className="w-12 h-12 bg-gradient-to-br from-green-600 to-blue-600 rounded-xl mb-4 group-hover:scale-105 transition-transform duration-300 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon" className="w-6 h-6 text-white">
                <path stroke-linecap="round" stroke-linejoin="round" d="m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"></path>
              </svg>
            </div>
            <h3 className="font-semibold text-gray-900 text-lg"> Managed Support</h3>
          </div>
        </div>
      </div>
    </div>
  </section>
 <HetznerServicesSection/>
 <HetznerInstallationSection />
   <HetznerSecuritySection/>
   <HetznerServiceIncludedSection/>
   <HetznerInstallationCTA openModal={openModal}/>
   <HetznerUsercases openModal={openModal}/>
    {/* <CustomerPortalSection/> */}
    <ContactSection/>
    </>
  );
};

export default Hetzner;
